import { render } from "./CenteredPanel.vue?vue&type=template&id=2578379f&scoped=true"
const script = {}

import "./CenteredPanel.vue?vue&type=style&index=0&id=2578379f&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2578379f"]])

export default __exports__